export default __webpack_public_path__ + "static/media/CamelOption1.f233a931.jpg";